<template>
  <div ref="chart" class="echart" :style="{ height }" />
</template>

<script lang="ts">
import Vue from 'vue';
import * as echarts from 'echarts';

/** 本组件支持的 option 类型 */
export type EChartOption = echarts.EChartsOption;

export default Vue.extend({
  name: 'EChart',
  props: {
    option: { type: Object as () => EChartOption, required: true },
    height: { type: String, default: '240px' },
  },
  data() {
    return { chartInstance: null as echarts.ECharts | null };
  },
  watch: {
    option: { handler: 'renderChart', deep: true },
  },
  mounted() {
    const element = this.$refs.chart as HTMLDivElement;
    this.chartInstance = echarts.init(element);
    this.chartInstance.on('click', ((params: unknown) => this.$emit('click', params)) as any);
    window.addEventListener('resize', this.resizeChart);
    this.renderChart();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    this.chartInstance?.dispose();
    this.chartInstance = null;
  },
  methods: {
    renderChart() {
      this.chartInstance?.setOption(this.option, { notMerge: true });
    },
    resizeChart() {
      this.chartInstance?.resize();
    },
  },
});
</script>

<style lang="scss" scoped>
.echart {
  width: 100%;
}
</style>
